import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router';

import { AuthContext } from '../context/auth-context.tsx';
import { Loading } from '../loading.tsx';

export const AdminRoute = () => {
  const { user, loading } = useContext(AuthContext);

  if (loading) return <Loading />;

  if (user && !user.isAdmin) return <Navigate to='/' />;

  return <Outlet />;
};
